import di from "@di";
import * as React from "react";
import { createRef, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { integerExp } from "../../utils/regex";
import { forEach } from "underscore";

export interface IYobInputFieldProps {
  placeholder?: string;
  onChange: (value: string) => void;
  defaultValue?: string;
  type?: string;
  id?: string;
  parentsId?: string;
  disabled?: boolean;
  min?: number;
  max?: number;
  inputClassName?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onKeyPress?: Function;
  childClassName?: string;
  showConfirmPinInNumbers?: boolean;
  focus?: boolean;
  otpLength?: number;
}

enum EKeyCodes {
  BACKSPACE = "Backspace",
  LEFT_ARROW = "ArrowLeft",
  RIGHT_ARROW = "ArrowRight",
  UNIDENTIFIED = "Unidentified",
}
const exceptThisSymbols = ["e", "E", "+", "-", ".", ","];

function handlekeyEvent(e: any): void {
  exceptThisSymbols.includes(e.key) && e.preventDefault();
}

const YobInputField: React.FC<IYobInputFieldProps> = (props) => {
  // stores the value of each input in array
  const [InpValue, setInpValue] = useState(["", "", "", ""]);
  // when focussed, this helps to colour the border of input_field_con
  const [focusClass, setFocusClass] = useState("focus");
  const otpRefs = React.useRef<Array<HTMLInputElement | null>>([]);
  const focusOtp = (index: number) => {
    otpRefs.current[index]?.focus();
  };

  const handleChange = (
    e: React.FormEvent<HTMLInputElement>,
    i: number,
  ): void => {
    const { value } = e.currentTarget;
    // Immediately return if the value contains any non-digit character
    if (!/^\d*$/.test(value)) {
      e.currentTarget.value = InpValue[i]; // Reset to previous valid value
      return;
    }

    // Handle Android keyboard input
    // Only allow single digit numeric input
    if (value.length > 1) {
      // Take just the last character if multiple digits entered
      const lastChar = value.slice(-1);
      if (!/^\d$/.test(lastChar)) {
        e.currentTarget.value = InpValue[i]; // Reset to previous valid value
        return;
      }
      e.currentTarget.value = lastChar;
      return handleChange(e, i);
    }

    // Update the value in the array
    const valueCopy = [...InpValue];
    valueCopy[i] = value;
    setInpValue(valueCopy);

    // Notify parent component of change
    props.onChange(valueCopy.join(""));

    // Auto-advance to next input if value entered
    if (value !== "") {
      const form = e.currentTarget.form;
      const index = Array.prototype.indexOf.call(form, e.currentTarget);
      const nextInput = form?.elements[
        index < InpValue.length - 1 ? index + 1 : index
      ] as HTMLInputElement;
      nextInput?.focus();
    }
  };

  function handleKeyUp(e: React.KeyboardEvent<HTMLInputElement>) {
    if (
      e.key === EKeyCodes.LEFT_ARROW.toString() ||
      e.key === EKeyCodes.RIGHT_ARROW.toString()
    ) {
      const form = (e.target as HTMLInputElement).form;
      const index = Array.prototype.indexOf.call(form, e.target);
      if (e.key === EKeyCodes.LEFT_ARROW.toString() && index > 0) {
        const prevInput = form?.elements[index - 1] as HTMLInputElement;
        prevInput?.focus();
      } else if (
        e.key === EKeyCodes.RIGHT_ARROW.toString() &&
        index < InpValue.length - 1
      ) {
        const nextInput = form?.elements[index + 1] as HTMLInputElement;
        nextInput?.focus();
      }
    }
  }

  const maxLengthCheck = (event: React.FormEvent<HTMLInputElement>) => {
    if (event.currentTarget.value.length > event.currentTarget.maxLength) {
      event.currentTarget.value = event.currentTarget.value.slice(
        0,
        event.currentTarget.maxLength,
      );
    }
  };

  const handleInput = (e: React.FormEvent<HTMLInputElement>, i: number) => {
    // maxLengthCheck(e);

    handleChange(e, i);
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    i: number,
  ) => {
    if (e.key === "Backspace" && InpValue[i] !== "") {
      return; // Stay in current input if it has a value
    }
    if (e.key === "Backspace" && i > 0) {
      const form = e.currentTarget.form;
      const index = Array.prototype.indexOf.call(form, e.currentTarget);
      const prevInput = form?.elements[index - 1] as HTMLInputElement;
      prevInput?.focus();
    }
  };

  React.useEffect(() => {
    if (props.defaultValue === "") {
      if (props?.otpLength) {
        setInpValue(Array.from(new Array(props?.otpLength), (val, idx) => ""));
      } else {
        setInpValue(["", "", "", ""]);
      }
      const firstInputBox = document.getElementById("otp-0");
      firstInputBox?.focus();
    }
  }, [props.defaultValue, props?.otpLength]);

  React.useEffect(() => {
    if (props?.otpLength) {
      setInpValue(Array.from(new Array(props?.otpLength), (val, idx) => ""));
    }
  }, [props?.otpLength]);

  return (
    <>
      <div className={`yob_inp_grp row mx-0 ${props?.parentsId}`}>
        {InpValue.map((inputValue, i) => (
          <input
            key={i}
            ref={(el) => (otpRefs.current[i] = el)}
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder={props.placeholder}
            value={inputValue}
            onFocus={() => setFocusClass(" focus")}
            onBlur={() => setFocusClass(" ")}
            className={`yob_inp mg-b10 col ${focusClass} ${
              props.childClassName ? props.childClassName : ""
            }`}
            type="tel"
            min={props.min ? props.min : 0}
            max={props.max ? props.max : 9}
            maxLength={4}
            onKeyUp={(e) => handleKeyUp(e)}
            onKeyDown={(e) => handleKeyDown(e, i)}
            id={props.id ? props.id + i : "yob-" + i}
            autoFocus={props?.focus === false ? false : i == 0 ? true : false}
            disabled={props.disabled}
            onChange={(e) => {
              console.log(e.currentTarget.value)
              if (e.target.value.length === InpValue.length) {
                const digits = e.target.value.split("");
                setInpValue(digits);
                props.onChange(digits.join(""));
                focusOtp(3);
              } else {
                handleInput(e, i);
              }
            }}
          />
        ))}
      </div>
    </>
  );
};

export default YobInputField;
